export default __webpack_public_path__ + "static/media/products-lamine.e253e585.jpg";